import client, {QueryOptions, MutationOptions} from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"
import {DealSettingsInput, DealSettings} from "@irati/types"
import perksSettingsErrorHandler from "./errors/perksSettingsErrorHandler"

import perksSettingsQuery, {perksSettingsKey} from "./queries/dealSettings"
import perksSettingsMutation, {perksSettingsMutationKey} from "./mutations/updateDealSettings"

class PerksSettingsService extends PBService {
  get(tenantId: string, options: QueryOptions = {}): Promise<DealSettings> {
    const variables = {tenantId}
    return client.query({...options, query: perksSettingsQuery, variables}).then(({data}) => data[perksSettingsKey])
  }

  update(tenantId: string, settings: DealSettingsInput, options: MutationOptions = {}): Promise<DealSettings> {
    const variables = {tenantId, settings}
    return client
      .mutate({...options, mutation: perksSettingsMutation, variables})
      .then(({data}) => this.updateCache(tenantId, data[perksSettingsMutationKey]))
  }

  private updateCache(tenantId: string, data: DealSettings) {
    const variables = {tenantId}
    client.writeQuery({query: perksSettingsQuery, variables, data: {[perksSettingsKey]: data}})
    return data
  }

  getSync(tenantId: string): DealSettings {
    try {
      const variables = {tenantId}
      return client.readQuery({query: perksSettingsQuery, variables})[perksSettingsKey]
    } catch (e) {
      this.get(tenantId)
      return {}
    }
  }
}

const service = new PerksSettingsService({errorHandlers: [perksSettingsErrorHandler]})

export default service
